<template>
  <app-layout ref="appLayout">
    <template v-slot:submenu>
      <sub-menu>
        <router-link :to="routeToSite" class="btn btn-outline-dark">
          <show-icon name="back" size="sm" class="align-middle"></show-icon>
          {{ $t("models.site") }}          
        </router-link>
      </sub-menu>
    </template>

    <template v-slot:default>

      <page-header>
        <h4 class="lh-1 m-0">{{ site.name }}</h4>
        <small v-if="site_company">{{ site_company.name }}</small>
      </page-header>

      <hr class="md-2">

      <div class="row">
        <div class="col-6 col-sm-3 text-end">
          <b>{{ $t("attributes.site.address") }}</b>
        </div>          
        <div class="col-6 col-sm-3 text-start">
          <p class="m-0" v-if="site.address">{{ site.address }}</p>
          <p class="m-0" v-if="site.city">{{ site.city }}</p>
          <p class="m-0" v-if="site.province">{{ site.province }}</p>
          <p class="m-0" v-if="site.post_code">{{ site.post_code }}</p>
          <p class="m-0" v-if="site.country_code">{{ site.country_code }}</p>
          <p></p>
        </div>

        <div class="col-6 col-sm-3 text-end">
          <b>{{ $t("attributes.lat") }} / {{ $t("attributes.long") }}</b>
        </div>
        <div class="col-6 col-sm-3 text-start">
          <p>{{ site.lat }}, {{ site.long }}</p>
          <google-map-button :lat="site.lat" :long="site.long"></google-map-button>
        </div>
      </div>      

      <hr class="md-2">

      <div class="row justify-content-center my-1 mx-1">
        <div style="height:55vh; width:100%">
          <l-map ref="map" :zoom="zoom" :center="center" @ready="onMapReady()">

            <l-marker :lat-lng="[site.lat, site.long]">
              <l-popup>
                <strong class="d-block text-gray-dark mb-1">{{ site.name }}</strong>
              </l-popup>
            </l-marker>

            <l-tile-layer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              layer-type="base"
              name="OpenStreetMap"
            ></l-tile-layer>

          </l-map>
        </div>
      </div>

    </template>
  </app-layout>
</template>

<script>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

import "leaflet/dist/leaflet.css";
//import { divIcon } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "@vue-leaflet/vue-leaflet";

import { routeToObject } from '@/common/url_path_helper';
import GoogleMapButton from '@/components/GoogleMapButton';

export default {
  setup() {
    const route = useRoute();
    const store = useStore();
    const site_uuid = route.params.id;
    const site = store.getters.getSite(site_uuid);
    const site_company = site.company_uuid ? store.getters.getCompany(site.company_uuid) : null;
    const routeToSite = routeToObject('Site', site_uuid);

    // setup the leaflet js for map
    const map = null; // to be setup in onMapReady() method once the leaflet map is ready
    const zoom = site.map_zoom_level ? ref(site.map_zoom_level) : ref(15);
    const center = ref([site.lat, site.long]);
    //const icon=divIcon({
    //  iconSize: "auto",
    //  html: "<span class='material-icons md-18 align-middle' style='vertical-align: text-bottom;'>location_on</span>"
    //})
    const google_map_link = `https://www.google.com/maps/search/?api=1&query=${site.lat},${site.long}`

    // for i18n
    const { t } = useI18n({ useScope: 'global' });
    return {
      site,
      site_company,
      routeToSite,
      zoom,
      center,
      map,
      //icon,
      google_map_link,
      t
    }
  },
  methods: {
    onMapReady() {
      if (this.bounds) {
        this.map = this.$refs.map.leafletObject;
        //this.map.fitBounds(this.bounds);
      }
    }
  },  
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    GoogleMapButton
  }
}
</script>